export class InvariantError extends Error {
  constructor(public message: string) {
    super();
    this.name = "InvariantError";
  }
}

export function invariant(
  condition: boolean,
  message?: string
) {
  if (!condition) { throw new InvariantError(message ? message : "Invariant error"); }
}



// WEBPACK FOOTER //
// ./src/helpers/invariant.ts